import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';
import { discountTemplatesKeys } from '../../api/query-keys/discount-templates';

import { DiscountTemplate } from '@/features/hosts/api/types/discount';

export const useDiscountTemplates = () => {
  return useQuery<{ templates: DiscountTemplate[] }, ApiError>({
    queryKey: discountTemplatesKeys.list(),
    queryFn: hostsApi.fetchDiscountTemplates,
  });
};
